import { Fragment, useState, useRef, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Fuse from 'fuse.js'

import { testPages, Page } from '../pages'

const truncateString = (str: string, num: number) => {
  if (str.length <= num) {
    return str
  }
  return str.slice(0, num) + '...'
}

const PageSearch = () => {
  const [searchValue, updateSearchValue] = useState('')
  const searchBarRef = useRef<HTMLInputElement>(null)
  useEffect(() => { searchBarRef.current?.focus() }, [])

  const fuse = new Fuse(testPages, { includeScore: true, keys: ['name', 'tags'], distance: 12 })
  const results = fuse.search(searchValue).map(result => result.item)

  return (
    <div>
      <div className='page-search'>
        <h2>Search</h2>

        <input
          autoFocus
          ref={searchBarRef}
          value={searchValue}
          onChange={({ target: { value } }: { target: { value: string } }) => updateSearchValue(value)}
          placeholder='Input page name or tags'
          className='page-search-input'
          type='text'
        />
      </div>

      {results.length !== 0 && (
        <div>
          <div className='page-search-results'>
            <h3>Results</h3>
            <dl>
              {results.map((result: Page) => (
                <Fragment>
                  <dt key={result.path}>
                    <Link to={result.path}>{result.name}</Link>
                  </dt>

                  <dd>{truncateString(result.content, 100)}</dd>
                </Fragment>
              ))}
            </dl>
          </div>
        </div>
      )}
    </div>
  )
}

export default PageSearch
